<script>
    export let email;
</script>
    
<label for="email">Email : </label>
<input id="email" type="email" name="email" bind:value={email}/>